module.exports = __webpack_public_path__ + "static/media/MJ-logo wide-wht.befcd1c8.svg";